
export function checkLuhn(num) {
    var arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
        len = num.length,
        bit = 1,
        sum = 0,
        val;

    while (len) {
        val = parseInt(num.charAt(--len), 10);
        sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
}

export function getLuhnSsn(ssn) {
    ssn = ssn.replace(/[^0-9]/, '');
    return ssn.length == 12 ? ssn.substring(2) : ssn;
}

export function checkSsnPattern(ssn) {
    var pattern = /^(19|20)*\d{6}-*\d{4}$/;
    return pattern.test(ssn);
}

export function getFullSsn(ssn) {
    ssn = ssn.replace(/[^0-9]/, '');
    return ssn.length == 10 ? '19' + ssn : ssn;
}